/**
 * @generated SignedSource<<611f2d199629e8c9a61687a5a159c4d3>>
 * @relayHash 88d5c6579a28e20dcf575092a5c52fcc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc64329afc4f8c4a77fa3341d0f1f69f82f1a9fd34c273333a11f1cdeecc097d

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkSuggestionsActionInput = {
  cloudId: string;
  taskId: string;
};
export type useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation$variables = {
  input: WorkSuggestionsActionInput;
};
export type useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation$data = {
  readonly workSuggestions: {
    readonly removeTask: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation = {
  response: useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation$data;
  variables: useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "WorkSuggestionsMutation",
    "kind": "LinkedField",
    "name": "workSuggestions",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "WorkSuggestionsActionPayload",
        "kind": "LinkedField",
        "name": "removeTask",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "bc64329afc4f8c4a77fa3341d0f1f69f82f1a9fd34c273333a11f1cdeecc097d",
    "metadata": {},
    "name": "useWorkSuggestionsAction_WorkSuggestionsRemoveTaskMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5f123b06555facf1457ce8ba9ee89177";

export default node;
